import LegalPage from '@/components/Legal/LegalPage';

export default function PrivacyRoute() {
  return <LegalPage docKey="privacy" />;
}
